import * as types from './constants';
import * as settingsTypes from '../../settings/constants';

const getIsReady = ({ accessToken, uuid, sendbirdAppId }) => Boolean(sendbirdAppId && uuid && accessToken);

const initialState = {
  data: {},
  sendbirdAppId: null,
  isReady: false,
  loading: false,
  errors_api: {}
};

const actions = {
  // Sendbird Token
  [types.GET_SENDBIRD_TOKEN_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      isReady: false
    };

    return { ...data };
  },

  [types.GET_SENDBIRD_TOKEN_DONE]: (state, { payload }) => {
    const accessToken = payload?.access_token || null;
    const uuid = payload?.uuid || null;
    const data = {
      ...state,
      loading: false,
      data: payload,
      isReady: getIsReady({ accessToken, uuid, sendbirdAppId: state.sendbirdAppId })
    };

    return { ...data };
  },

  [types.GET_SENDBIRD_TOKEN_FAILED]: state => {
    const data = {
      ...state,
      loading: false,
      isReady: false
    };

    return { ...data };
  },

  [settingsTypes.GET_SETTINGS_DONE]: (state, { payload }) => {
    const sendbirdAppId = payload?.sendbird_app_id || null;
    const accessToken = state.data?.access_token || null;
    const uuid = state.data?.uuid || null;
    const data = {
      ...state,
      sendbirdAppId,
      isReady: getIsReady({ accessToken, uuid, sendbirdAppId })
    };

    return { ...data };
  },

  [settingsTypes.GET_SETTINGS_FAILED]: state => {
    const data = {
      ...state,
      sendbirdAppId: null,
      isReady: false
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

